import { useCallback } from "../../../__compat__/react/main.entry.mjs.mjs";
import { isWithinInterval, startOfDay, endOfDay, } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
export const useCalendarMinMax = (minDate, maxDate) => {
    const getMinMaxProps = useCallback((date) => isWithinInterval(date, {
        start: startOfDay(minDate),
        end: endOfDay(maxDate),
    })
        ? {}
        : { disabled: true }, [minDate, maxDate]);
    return { getMinMaxProps };
};
//# sourceMappingURL=useCalendarMinMax.mjs.mjs.map